import { render, staticRenderFns } from "./EditNormalizedNameDialog.vue?vue&type=template&id=38775edc"
import script from "./EditNormalizedNameDialog.vue?vue&type=script&lang=js"
export * from "./EditNormalizedNameDialog.vue?vue&type=script&lang=js"
import style0 from "./EditNormalizedNameDialog.vue?vue&type=style&index=0&id=38775edc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports